import React from 'react';

const FrontPagePackage = () => {
    return (
        <div className="taco-intro">
            {/* Contenedor de Logos y Título */}
            <div className="taco-intro__logo-container">
                <div className='d-flex align-items-center justify-content-center'>
                    {/* <img src='/img/favicon/Big.png' style={{ width: '100%', maxWidth: '120px', marginRight: '40px' }} alt="Sponsor Left" /> */}
                    
                    {/* Logo central (ej. La Moderna, ADSL, o la marca patrocinadora) */}
                    <img src="/img/page/adsl-five.png" className="taco-intro__logo" alt="Patrocinador Central" />
                    
                    {/* <img src='/img/favicon/Big.png' style={{ width: '100%', maxWidth: '120px', marginLeft: '30px' }} alt="Sponsor Right" /> */}
                </div>
                
                <p className="taco-intro__text text-uppercase fw-bold mt-4">Presentan</p>
                {/* <p className="taco-intro__title text-uppercase fw-black">Día del Taco</p> */}
                <p className="taco-intro__title text-uppercase fw-black">De regreso al Barrio 9</p>
            </div>

            {/* El taco animado que cae y rebota. 
                Usamos la imagen '4.png' asumiendo que es el taco ya con salsa y todo armado */}
            {/* <img src="/img/games/taco/4.png" className="taco-intro__taco" alt="Taco Gigante" /> */}

            <p className='FooterCredits' style={{ position: 'fixed', bottom: '0', left: '50%', transform: 'translateX(-50%)', fontSize: '30px', color: '#fff' }}>Hecho con ♥ por Interaktia | 2026</p>
        </div>
    );
};

export { FrontPagePackage };